import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { useParams } from 'react-router-dom';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';

export default function useGetEmployeeMedicalDetails() {
  const { id } = useParams();

  return useQuery(['employee-medical-details'], async () => {
    const res = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.EMPLOYEE_MEDICAL_DETAILS_API, {
        employee_id: id,
      })
    );
    return res.data;
  });
}
